<template>
    <div id="LoginPage">
        <div class="ui center aligned padded middle aligned grid" style="height: 95vh;">
            <div class="column" style="text-align: center; max-width:350px;">
                <div id="LoginBox">
                    <img href="#" src="img/logos/sso7.png" width="120px" style="padding-top: 20px;">

                    <p style="padding-top: 25px; padding-bottom: 20px;"> <b>{{ $t("login.title") }} {{logintext}} Single Sign On</b></p>
                    <div class='field'>
                        <labelinput v-model="user.name" v-on:update-value="updateUserName" label="Username"></labelinput><br><br>
                    </div>
                    <div class='field' v-on:keyup.enter="login">
                        <!--<labelinputpw v-model="user.password" v-on:update-value="updateUserPassword" label="Password"></labelinputpw><br><br>-->
                        <div class="ui fluid labeled action input">
                            <input type="password" class="ssoinput" v-model="user.password" placeholder="Password">
                            <button class="ui gray icon button" v-on:click='login'>
                              <i class="arrow alternate circle right outline icon"></i>
                            </button>
                        </div>
                    </div>
                    <div class="field">
                        
                    </div>
                    <!--<div class='field'>
                        <button class="ui fluid teal button" style="width: 100%;" v-on:click=login>{{ $t("login.goon") }}</button>
                    </div>-->
                    <br>
                    <div v-if="loading == true" class="field">
                        <div class="ui active centered inline loader"></div>
                    </div>
                    <br><br>
                    <div class='field'>
                        <div class='ui input'>
                            <transition name="fade" mode="out-in">
                                <div v-if="nonvaliddata == true" style="width: 100%; margin-bottom: 25px;">
                                    <div class="ui negative message">
                                        <div class="header">
                                            {{loginresponse}}
                                        </div>
                                    <p></p></div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <div style="text-align: center; z-index: 1000000; position: relative; color: white; bottom: 35px">
                <a tabindex="-1" target="_blank" href="https://www.trentinosviluppo.it"> <img href="#" src="img/logos/TrentinoSviluppoWhite.png" width="200px"></a>
            </div>

    </div>
</template>

<script>
// @ is an alias to /src
import router from '../router'
import labelinput from '@/components/textinput.vue'
import theme from '@/components/theme.js'

const $ = require('jquery')
window.$ = $

export default {
    props: [],
    name: 'login',
    data: function () {
        return {
            user: {name: "", password: ""}, 
            loginresponse: "", 
            loading: false,
            imagelogin: "", 
            nonvaliddata: false,
            logintext: ""
        }
    },
    components: {
        labelinput
    },
    methods: {
        login: function() {
            this.loading = true;
            this.nonvaliddata = false;
            $.post(this.baseUrl + "/login/user", this.user).done(function( response ) {
                this.loading = false;
                if (response["response"] == "done") {
                    router.push({name: 'servicepage'});
                } else if (response["response"] == "notauthorized" || response["response"] == "notauth"){
                    this.nonvaliddata = true;
                    this.loginresponse = "Login not valid";
                } else {
                    this.nonvaliddata = true;
                    this.loginresponse = "Banned";
                }
            }.bind(this));
        },
        updateUserName: function(val) {
            this.user.name = val;
        },
        updateUserPassword: function(val) {
            this.user.password = val;
        }
    },
    beforeMount: function () {
        $.getJSON(this.baseUrl + "/isauth", function(data) { 
            if (data["response"] == true) { router.push({name: 'servicepage'} ) }
        }.bind(this));
        if (window.location.href.indexOf("trentinosviluppo") !== -1 || window.location.href.indexOf("localhost") !== -1) {
            this.imagelogin = "images/ssologo.png";
            this.logintext = "Trentino Sviluppo";
        } else {
            this.imagelogin = "images/promlogot.png";
            this.logintext = "ProM Facility";
        }
        if (navigator.language.toLowerCase().indexOf("it") !== -1) {
            this.$i18n.locale = 'it';
        } else {
            this.$i18n.locale = 'en';
        }
    },
    mounted: function () {
        theme.setTheme(false, '')
    },
    updated: function () {
        
    }
}
</script>

<style lang="scss" >
@import "@/style/comon.scss";

#LoginPage {
    @extend %mainbackground;
    min-height: 100vh;
    color: white;
}
</style>



